import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './AccordionFAQ.css';
import React from 'react';
import { get } from '../../utils';
import RouterLink from '../atoms/RouterLink';
import { RichText, Text, Link as SitecoreLink } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import IconPlus from '../atoms/Icons/IconPlus';
import IconMinus from '../atoms/Icons/IconMinus';
import { tealiumMergeClickData, tealiumClickFunc } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import { isNil } from '../../utils/IsNil';
export var AccordionFAQ = function AccordionFAQ(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeItemsIds = _React$useState2[0],
    setActiveItemsIds = _React$useState2[1];
  var titleField = get(fields, 'data.item.title.field');
  var titleFieldValue = String(titleField ? titleField.value || '' : '');
  var readAllLabel = get(fields, 'data.item.readAllLabel.field.value');
  var readAllLabelField = get(fields, 'data.item.readAllLabel');
  var readAllLinkField = get(fields, 'data.item.readAllLink.field');
  var href = get(fields, 'data.item.readAllLink.field.value.href', '/');
  var readAllLinkHref = href.endsWith('pdf') ? "".concat(sitecoreContext.origin, "/").concat(href) : href;
  var hasItems = Boolean(get(fields, 'data.item.items.targetItems.length'));
  var filteredItems = function filteredItems() {
    var notFilteredItems = hasItems ? fields.data.item.items.targetItems : [];
    return notFilteredItems.filter(function (item) {
      var title = get(item, 'title.field.value');
      if (isNil(title) || title === "") {
        return false;
      }
      return item;
    });
  };
  var items = filteredItems();
  var middleArrIndex = hasItems ? Math.ceil(items.length / 2) : 0;
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  React.useEffect(function () {
    var isFirstExpanded = Boolean(get(fields, 'data.item.isFirstExpanded.field.value'));
    if (pageEditing) {
      setActiveItemsIds(items.length ? items.map(function (i) {
        return i.id;
      }) : []);
    } else if (isFirstExpanded && hasItems) {
      setActiveItemsIds(items.length ? [items[0].id] : []);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleAccordionItemClick = React.useCallback(function (e, id, isActive) {
    e.preventDefault();
    var nextActiveItemsIds = isActive ? activeItemsIds.filter(function (i) {
      return i !== id;
    }) : [].concat(_toConsumableArray(activeItemsIds), [id]);
    setActiveItemsIds(nextActiveItemsIds);
  }, [activeItemsIds]);
  if (!fields || !fields.data || !fields.data.item) {
    console.info('AccordionFAQ component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", null, "[AccordionFAQ component is empty: please provide data source]");
    }
    return null;
  }
  var renderItem = function renderItem(item, pageEditing) {
    var isActive = pageEditing || activeItemsIds.includes(item.id);
    var titleField = get(item, 'title.field');
    var description = get(item, 'description.field');
    var name = get(item, 'name');
    var titleValue = titleField ? titleField.value : '';
    var descriptionValue = description ? description.value : '';
    if (titleValue && descriptionValue) {
      return /*#__PURE__*/React.createElement("div", {
        className: "accordion__list ".concat(isActive ? "accordion__list--active" : ""),
        key: item.id
      }, /*#__PURE__*/React.createElement("p", {
        className: "accordion__heading body-medium",
        onClick: function onClick(e) {
          if (!pageEditing) {
            handleAccordionItemClick(e, item.id, isActive);
            tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['questionAnalytics'], params), "".concat(name, ": ").concat(isActive ? 'Collapse' : 'Expand'));
          }
        },
        onKeyPress: function onKeyPress(e) {
          if (e.key === " " || e.key === "Spacebar") {
            e.preventDefault();
            handleAccordionItemClick(e, item.id, isActive);
            tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['questionAnalytics'], params), "".concat(name, ": ").concat(isActive ? 'Collapse' : 'Expand'));
          }
        }
      }, /*#__PURE__*/React.createElement(Text, {
        tag: pageEditing ? 'span' : 'a',
        className: "accordion__anchor",
        href: "/",
        field: titleField,
        "data-cy": "accordion-faq-anchor"
      }), !pageEditing && /*#__PURE__*/React.createElement("span", {
        className: "accordion__icon"
      }, isActive ? /*#__PURE__*/React.createElement(IconMinus, null) : /*#__PURE__*/React.createElement(IconPlus, null))), isActive && /*#__PURE__*/React.createElement("div", {
        className: "accordion__content"
      }, /*#__PURE__*/React.createElement(RichText, {
        tag: "p",
        className: "body-small accordion__desc",
        field: description,
        "data-cy": "accordion-faq-item-content"
      })));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: "\n          {\n            \"@context\": \"https://schema.org\",\n            \"@type\": \"FAQPage\",\n            \"mainEntity\": [\n\n            ".concat(items.map(function (item) {
        return "{\n                \"@type\": \"Question\",\n                \"name\": ".concat(JSON.stringify(get(item, 'title.field.value')), ",\n                \"acceptedAnswer\": {\n                  \"@type\": \"Answer\",\n                  \"text\": ").concat(JSON.stringify(get(item, 'description.field.value')), "\n                }\n              }");
      }), "]\n          }")
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "row m01-accordion-faq"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-faq",
    "data-cy": "accordion-faq"
  }, titleField && titleFieldValue && titleFieldValue.trim() && /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 accordion-main-heading",
    field: titleField,
    "data-cy": "accordion-faq-title"
  }), /*#__PURE__*/React.createElement("div", {
    className: "accordion accordion--faq"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion__col accordion__col--left"
  }, items.map(function (item, index) {
    if (index < middleArrIndex) {
      if (item.children && item.children.length > 0) {
        var description = get(item, 'description.jss.value') || '';
        return /*#__PURE__*/React.createElement("div", {
          className: "accordion-faq-category"
        }, description && /*#__PURE__*/React.createElement("span", {
          className: "label-small"
        }, description), item.children.map(function (el) {
          return renderItem(el, pageEditing);
        }));
      } else {
        return renderItem(item, pageEditing);
      }
    }
    return null;
  })), /*#__PURE__*/React.createElement("div", {
    className: "accordion__col accordion__col--right"
  }, items.map(function (item, index) {
    var description = get(item, 'description.jss.value') || '';
    if (index >= middleArrIndex) {
      if (item.children && item.children.length > 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "accordion-faq-category"
        }, description && /*#__PURE__*/React.createElement("span", {
          className: "label-small"
        }, description), item.children.map(function (el) {
          return renderItem(el, pageEditing);
        }));
      } else {
        return renderItem(item, pageEditing);
      }
    }
    return null;
  }))), pageEditing ? /*#__PURE__*/React.createElement(SitecoreLink, {
    className: "btn btn-link accordion__readmore",
    field: readAllLinkField,
    title: readAllLabel ? readAllLabel : '[Link]'
  }, /*#__PURE__*/React.createElement(Text, {
    field: readAllLabelField,
    tag: "span",
    className: "btn-link__text"
  }), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon btn-link-icon"
  })) : readAllLabel && readAllLinkHref && readAllLinkHref !== '/' && /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-link accordion__readmore",
    href: readAllLinkHref,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['readAllAnalytics'], params));
    },
    dataCy: "accordion-faq-read-more",
    title: readAllLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-link__text"
  }, readAllLabel), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon btn-link-icon"
  })))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "cb58dqw";
var ltrStyles = "l14ytd6h";
var rtlStyles = "r1jxjn18";
export default AccordionFAQ;